import React, { useState, useEffect, useCallback, useRef } from 'react'
import '@/assets/css/insertPublish.css'
import '@/assets/css/audioDesc.css'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import NewAudioClipComponent from '../NewAudioClip/NewAudioClip'
import ModalComponent from '../../../shared/components/Modal/Modal'
import { toast } from 'react-toastify'
import { userDataStore } from '@/App'

interface Props {
  handleClicksFromParent: string
  setHandleClicksFromParent: React.Dispatch<React.SetStateAction<string>>
  seconds: number
  reset: () => void
  setShowSpinner: React.Dispatch<React.SetStateAction<boolean>>
  userId: string
  youtubeVideoId: string
  currentTime: number
  videoLength: number
  audioDescriptionId: string
  participantId: string
  setNeedRefresh: React.Dispatch<React.SetStateAction<boolean>>
  tutorialMode?: boolean
  forceShowNewACComponent?: boolean
}

const InsertPublish = ({
  handleClicksFromParent,
  setHandleClicksFromParent,
  seconds,
  reset,
  setShowSpinner,
  userId,
  youtubeVideoId,
  currentTime,
  videoLength,
  audioDescriptionId,
  participantId,
  setNeedRefresh,
  tutorialMode = false,
  forceShowNewACComponent = false,
}: Props) => {
  const navigate = useNavigate()
  const [showInlineACComponent, setShowInlineACComponent] = useState(false)
  const [showNewACComponent, setShowNewACComponent] = useState(false)
  const [isModal, setIsModal] = useState(false)
  const [insertClipStartTimeSnapshot, setInsertClipStartTimeSnapshot] =
    useState(currentTime)
  // Keep a ref so openNewAudioClip always reads the latest time without
  // needing currentTime as a useCallback dep (which would recreate it on
  // every tick and cause the trigger useEffect to re-run unnecessarily).
  const currentTimeSnapshotRef = useRef(currentTime)
  useEffect(() => {
    currentTimeSnapshotRef.current = currentTime
  }, [currentTime])

  const openNewAudioClip = useCallback((clipType: 'inline' | 'extended') => {
    setInsertClipStartTimeSnapshot(currentTimeSnapshotRef.current)
    setShowInlineACComponent(clipType === 'inline')
    setShowNewACComponent(true)
  }, [])

  const handleClickInsertInline = (e: any) => {
    e.preventDefault()
    openNewAudioClip('inline')
  }

  const handleClickInsertExtended = (e: any) => {
    e.preventDefault()
    openNewAudioClip('extended')
  }

  const handleClickPublish = (e: any) => {
    axios
      .post(
        `${process.env.REACT_APP_YDX_BACKEND_URL}/api/add-timedata-to-db/addtimedata`,
        {
          participant_id: participantId,
          time: seconds,
        },
      )
      .then(function (response) {
        reset()
      })
      .catch(function (error) {
        console.error(error)
      })
  }

  useEffect(() => {
    if (tutorialMode) {
      if (handleClicksFromParent) setHandleClicksFromParent('')
      setShowInlineACComponent(true)
      setShowNewACComponent(forceShowNewACComponent)
      return
    }

    if (handleClicksFromParent === 'inline') {
      setHandleClicksFromParent('')
      openNewAudioClip('inline')
    } else if (handleClicksFromParent === 'extended') {
      setHandleClicksFromParent('')
      openNewAudioClip('extended')
    }
  }, [
    forceShowNewACComponent,
    handleClicksFromParent,
    openNewAudioClip,
    setHandleClicksFromParent,
    tutorialMode,
  ])

  return (
    <React.Fragment>
      {showNewACComponent ? (
        <>
          <h5 className="text-white">
            Insert {showInlineACComponent ? 'Inline' : 'Extended'} Audio Clip
          </h5>
          <NewAudioClipComponent
            userId={userDataStore.getState().userId}
            youtubeVideoId={youtubeVideoId}
            showInlineACComponent={showInlineACComponent}
            setShowNewACComponent={setShowNewACComponent}
            initialStartTime={insertClipStartTimeSnapshot}
            videoLength={videoLength}
            audioDescriptionId={audioDescriptionId}
            setShowSpinner={setShowSpinner}
            setNeedRefresh={setNeedRefresh}
            tutorialMode={tutorialMode}
          />
        </>
      ) : null}
    </React.Fragment>
  )
}

export default InsertPublish
